import { Theme } from '@mui/material';
import { Components } from '@mui/material/styles';

export const muiDrawerOverride: Components<Theme>['MuiDrawer'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      width: '100%',
      backgroundColor: theme.colorSchemeSelector === 'light' ? theme.vars.palette.grey[50] : theme.vars.palette.background.paper,
      paddingTop: 16,
      paddingBottom: 16,
      paddingLeft: 28,
      paddingRight: 28,
      [theme.breakpoints.up('md')]: {
        maxWidth: 466,
        paddingTop: 39,
        paddingBottom: 39,
        paddingLeft: 58,
        paddingRight: 0,
      },
    }),
  },
};
